import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface RowActionsProps {
  children: ReactNode;
  isPersistent?: boolean;
}

const RowActions = ({ children, isPersistent }: RowActionsProps) => (
  <Stack
    direction="row"
    data-row-actions
    data-row-actions-persistent={isPersistent || undefined}
    sx={{ alignItems: 'center', gap: 0.5, flexShrink: 0 }}
  >
    {children}
  </Stack>
);

export default RowActions;
